module.exports = __webpack_public_path__ + "static/media/btn_download_apple_store.103f0f61.svg";